/**
 * 오프라인 감지 시 화면 상단에 고정 배너 표시
 * 온라인 복구 시 자동 해제 (2초 후 fade out)
 */
import React, { useEffect, useState } from 'react';
import { WifiOff, Wifi } from 'lucide-react';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';

export const OfflineBanner: React.FC = () => {
  const isOnline = useOnlineStatus();
  const [showRecovered, setShowRecovered] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setWasOffline(true);
    } else if (wasOffline) {
      // 온라인 복구 — 2초간 "연결됨" 표시 후 해제
      setShowRecovered(true);
      const timer = setTimeout(() => {
        setShowRecovered(false);
        setWasOffline(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [isOnline, wasOffline]);

  if (isOnline && !showRecovered) return null;

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[60] px-4 py-2 text-center text-sm font-medium transition-colors duration-300 ${
        isOnline
          ? 'bg-green-500 text-white'
          : 'bg-yellow-500 text-yellow-900'
      }`}
      role="alert"
    >
      <div className="flex items-center justify-center gap-2">
        {isOnline ? (
          <>
            <Wifi className="h-4 w-4" />
            <span>인터넷 연결이 복구되었습니다</span>
          </>
        ) : (
          <>
            <WifiOff className="h-4 w-4" />
            <span>오프라인 상태입니다. 일부 기능이 제한될 수 있습니다.</span>
          </>
        )}
      </div>
    </div>
  );
};
